import {Component, Inject, OnInit} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {MatDialog} from '@angular/material/dialog';
import {EmpusaAuthenticationService} from '@empusa/empusa-core';
import {SnackbarService} from '../../../services/snackbar.service';
import {SpinnerService} from '../../../services/spinner.service';
import {Combo, ComboService} from '../../../services/combo.service';
import {
  DiccionarioControllerService,
  DiccionarioElementoDTO,
  SolicitudReutilizacionControllerService,
  SolicitudReutilizacionEstadoControllerService,
  SolicitudReutilizacionEstadoDTO,
  SolicitudReutilizacionFilterDTO,
  SubTipoEnvaseControllerService,
  SubTipoEnvaseDTO,
  SubTipoEnvaseFilterDTO,
  TipoEnvasesControllerService,
  TipoEnvasesDTO,
  UsuarioSDDRCaDTO
} from 'api-rest';
import {zip, of} from 'rxjs';
import moment from 'moment';
import {DatePipe} from '@angular/common';
import {OpenSddrService} from '../../../services/open-sddr.service';
import {DownloadService} from '../../../services/download.service';
import Swal from 'sweetalert2';
import {OpenSsdrReuseDialogComponent} from '../open-ssdr-reuse-dialog/open-ssdr-reuse-dialog.component';
import {OpenSsdrReuseCertificateDialogComponent} from '../open-ssdr-reuse-certificate-dialog/open-ssdr-reuse-certificate-dialog.component';
import { OpenSddrReuseRejectDialogComponent } from '../open-sddr-reuse-reject-dialog/open-sddr-reuse-reject-dialog.component';

@Component({
  selector: 'open-sddr-open-sddr-remain-search',
  templateUrl: './open-sddr-reuse-search.component.html',
  styleUrls: ['./open-sddr-reuse-search.component.scss']
})
export class OpenSddrReuseSearchComponent implements OnInit {
  formSearch!: FormGroup;
  tiposUsuarios!: Combo[];
  tiposUsuariosSddr!: UsuarioSDDRCaDTO[];
  tiposEnvases!: TipoEnvasesDTO[];
  subtiposEnvases!: SubTipoEnvaseDTO[];
  usosEnvases!: Combo[];
  estados!: SolicitudReutilizacionEstadoDTO[];
  flagSearch: boolean = false;
  pageNumber: number = 0;
  pageSize: number = 25;
  totalElements: number = 0;
  itemsPerPageOptions: number[] = [25, 50, 75, 100];
  selectedItemsPerPage: number = 25;
  totalSearch: any = 0;
  ocultarBuscador: boolean = true;

  headArray: any = [
    {
      Head: 'ID',
      FieldName: 'id'
    },
    // {
    //   Head: 'Tipo usuario',
    //   FieldName: 'tipoUsuario'
    // }, 
    {
      Head: 'Razón social usuario',
      FieldName: 'razonSocial'
    }, {
      Head: 'Provincia',
      FieldName: 'provincia',
      renderValue: (item: any) => {
        let user = item.adherido ?? item.poseedor;
        // Primero "Física"
        let domicilio = user?.domicilios?.find((dom: any) => dom.tipoDireccion.descripcion === "Física");
        // Si no existe,"Social"
        if (!domicilio) {
          domicilio = user?.domicilios?.find((dom: any) => dom.tipoDireccion.descripcion === "Social");
        }
        // else null
        return domicilio?.provincia?.nombre || '';
      }
    }, {
      Head: 'Fecha solicitud',
      FieldName: 'fechaSolicitud',
      renderValue: (item: any) => this.datePipe.transform(item.fechaSolicitud, 'dd/MM/yyyy')
    },
    {
      Head: 'Tipo de envase ',
      FieldName: 'tipoEnvase',
      Attribute: 'descripcion'
    },
    //{
    //   Head: 'Subtipo de envase',
    //   FieldName: 'subTipoEnvase',
    //   Attribute: 'descripcion'
    // },
    //{
    //  Head: 'Lote envase',
    //  FieldName: 'loteEnvase'
    //},
    {
      Head: 'Núm. de envases a reutilizar',
      FieldName: 'numeroEnvases'
    },
    {
      Head: '¿Uso del envase?',
      FieldName: 'usoEnvase',
      renderValue: (item: any) => this.usosEnvases.find(x => item.usoEnvase === x.id)?.name
    },
    {
      Head: 'Estado',
      FieldName: 'estado',
      Attribute: 'descripcion',
      tooltipHeader: this.canViewResource('PO-POSEEDOR') ? "Resumen de estados:\n·Borrador: solicitud en proceso de cumplimentación. Pendiente de envío a ENVALORA.\n·Pendiente de Aceptación: solicitud enviada, pendiente de revisión por parte de ENVALORA.\n·Aceptada: solicitud de reutilización aceptada por ENVALORA.\n·Rechazada: solicitud de reutilización rechazada por ENVALORA.\n·Prefacturada: prefactura por retorno de depósitos emitida por ENVALORA." : ''
    },
    {
      Head: 'Prefacturada',
      FieldName: 'autoFactura',
      renderValue: (item: any) => item.autoFactura ? 'SI' : 'NO'
    },
    {
      Head: 'Acciones',
      FieldName: 'actions',
      check: this.canViewResource('SDDR-CA-ENV-GEST'),
      buttons: [
        {
          nameButton: 'view',
          icon: 'open_in_new',
          toolTip: 'Detalle',
          show: { params: 'canAccessView', accion: 'view' },
        },
        {
          nameButton: 'delete',
          icon: 'delete',
          toolTip: 'Borrar',
          show: { params: 'canAccessDelete', accion: 'delete' },
        }, {
          nameButton: 'menu',
          array: [
            {
              nameButton: 'sendRequest',
              name: 'Enviar solicitud ',
              show: { params: 'canAccessSendReq', accion: 'sendRequest' },
            },
            {
              nameButton: 'acceptRequest',
              name: 'Aceptar solicitud',
              show: { params: 'canAccessAcceptReq', accion: 'acceptRequest' },
            },
            {
              nameButton: 'rejectRequest',
              name: 'Rechazar solicitud',
              show: { params: 'canAccessRejectReq', accion: 'rejectRequest' },
            }
          ],
        }
      ],
      width: '10.2',
      permanent: true,
    },
  ];
  gridArray: any[] = [];

  updateList: boolean = false;

  listaPoseedores = this.environment.urlBackCore + 'api/v1/poseedores/poseedor';

  // Poseedores completados
  defaultGestoresParameters = { 'estado.id': 4 };
  orden: DiccionarioElementoDTO[] = [];
mostrarFiltros: boolean = true;
  constructor(
    @Inject('environment') private environment: any,
    public spinnerSrv: SpinnerService,
    private formBuilder: FormBuilder,
    private dialog: MatDialog,
    private snackBarSrv: SnackbarService,
    @Inject('EmpusaAuthenticationService') private authService: EmpusaAuthenticationService,
    private comboSrv: ComboService,
    private tipoEnvasesCtrSrv: TipoEnvasesControllerService,
    private solicitudReutilizacionCtrSrv: SolicitudReutilizacionControllerService,
    private subtipoEnvaseCtrSrv: SubTipoEnvaseControllerService,
    private solicitudReutilizacionEstadoCtrSrv: SolicitudReutilizacionEstadoControllerService,
    private datePipe: DatePipe,
    private openSddrSrv: OpenSddrService,
    private solicitudesReutilizacionCtrlSrv: SolicitudReutilizacionControllerService,
    private downloadSrv: DownloadService,
    private diccionarioControllerService: DiccionarioControllerService) {
    this.formSearch = this.formBuilder.group({
      tipoUsuario: [{ value: null, disabled: false }],
      idUsuario: [{ value: null, disabled: false }, [Validators.pattern('^[0-9]+$'), Validators.maxLength(10)]],
      usuarioSddr: [{ value: null, disabled: false }],
      tipoEnvase: [{ value: null, disabled: false }],
      //subtipoEnvase: [{ value: null, disabled: false }],
      loteEnvase: [{ value: null, disabled: false }],
      usoEnvase: [{ value: null, disabled: false }],
      fechaDesde: [{ value: null, disabled: false }],
      fechaHasta: [{ value: null, disabled: false }],
      estado: [{ value: null, disabled: false }],
      autofacturada: [{ value: null, disabled: false }],
      orden: [{ value: null, disabled: false }],
      tipoOrden: [{ value: null, disabled: false }],
    });
  }

  ngOnInit(): void {
    this.cargarCombos();
    //Solo los SDDR_CA_ENV_GEST y SDDR_CA_ENV_CONS verán el campo provinciano
    this.headArray = !this.canViewResource('SDDR-CA-ENV-GEST') || !this.canViewResource('SDDR-CA-ENV-CONS')
      ? this.headArray
      : this.headArray.filter(
        (head: any) =>
          head.FieldName !== 'provincia'
      );

    //Si no puede crear prefactura se elimina el check
    if (!this.canCrearAutofactura()) {
      this.removeCheck(this.headArray)
    }

    this.buscar(true, true)
  }

  removeCheck(list: any[]) {
    list.forEach((item) => {
      if (item.FieldName === 'actions' && item.check) {
        delete item.check;
      }
    });
    this.headArray = list;
  }
  checked(event: any) {
    if (event.estado.id != 3) {
      this.snackBarSrv.showSnackBar(
        'Solo se permitirá prefacturar solicitudes en estado Aceptada',
        'error'
      );
      event.checked = null;
    }
  }

  cargarCombos(): void {
    this.tiposUsuarios = this.comboSrv.getTiposUsuarioSolicitud();
    this.usosEnvases = this.comboSrv.getUsosEnvases();
    const tipoEnvaseFilter = { sddrca: true };
    const subtipoEnvaseFilter: SubTipoEnvaseFilterDTO = { tipoEnvase: { sddrca: true } };
    this.spinnerSrv.loadingShow();
    
    /**const usuariosSddrObservable = (this.canViewResource('PO-POSEEDOR') || this.canViewResource('AD-ADHERIDO'))
      ? this.solicitudReutilizacionCtrSrv.findAllUsuariosAsociados()
      : of([]);**/
    
    zip(
      this.tipoEnvasesCtrSrv.findAll(tipoEnvaseFilter, { page: 0, size: 100 }),
      this.solicitudReutilizacionCtrSrv.findAllUsuariosAsociados(),
      this.subtipoEnvaseCtrSrv.listarSubTipoEnvases(subtipoEnvaseFilter, { page: 0, size: 100 }),
      this.solicitudReutilizacionEstadoCtrSrv.listarSolicitudReutilizacionEstados({}, { page: 0, size: 500 }),
      this.diccionarioControllerService.listarElementos(['ORDEN_SDDR_ABIERTO_SOLICITUDES_REUTILIZACION_BUSQUEDA'])
    ).subscribe({
      next: (responses: any[]) => {
        this.spinnerSrv.loadingHide();
        this.tiposEnvases = responses[0].datos;
        this.tiposUsuariosSddr = responses[1].filter((item:any) => item.tipoUsuario !== 'ADHERIDO');
        this.subtiposEnvases = responses[2].datos;
        this.estados = responses[3].datos;
        this.orden = responses[4]['ORDEN_SDDR_ABIERTO_SOLICITUDES_REUTILIZACION_BUSQUEDA'];
      },
      error: (err) => {
        this.spinnerSrv.loadingHide();
      },
    });
  }

  clearSelection(event: Event, formName: string) {
    event.stopPropagation();
    this.formSearch.get(formName)?.setValue(null);
  }
  showClearButton(formName: string): boolean {
    return this.formSearch.get(formName)?.value !== null;
  }
  public rightHolder(controlName: string) {
    let cl2 = '';
    if (
      (this.formSearch.controls[controlName]?.touched ||
        this.formSearch.controls[controlName]?.dirty) &&
      this.formSearch.controls[controlName]?.errors
    ) {
      cl2 = 'error-focus-input';
    } else {
      cl2 = 'success-focus-input';
    }
    return `${cl2}`;
  }
  controlHasError(controlName: string, errorName: string) {
    return (
      this.formSearch.controls[controlName]?.hasError(errorName) &&
      this.formSearch.controls[controlName]?.touched
    );
  }
  renderPage(event: number) {
    this.pageNumber = event;
    if (this.flagSearch) {
      this.buscar();
    }
  }
  action(item: any) {
    if (item.nameButton == 'view') {
      this.abrirModal(item);

    } else if (item.nameButton == 'delete') {
      this.confirmacionBorrar(item);
    } else if (item.nameButton == 'sendRequest') {
      this.confirmacionEnviar(item)
    } else if (item.nameButton == 'acceptRequest') {
      this.confirmacionAceptar(item);
    } else if (item.nameButton == 'rejectRequest') {
      this.openModalMotivoRechazo(item)
    }
  }
  onItemsPerPageChange() {
    this.pageSize = this.selectedItemsPerPage;
    this.buscar();
  }
  limpiar(): void {
    this.formSearch.reset();
    this.flagSearch = false;
    this.gridArray = [];
  }

  toggleFiltros(): void {
    this.mostrarFiltros = !this.mostrarFiltros;
  }

  quitarFiltro(filtro: { label: string; campo: string; value?: any }): void {
    if (filtro.value !== undefined) {
      const current = this.formSearch.get(filtro.campo)?.value as any[];
      if (Array.isArray(current)) {
        const updated = current.filter((v) =>
          v?.id !== undefined && filtro.value?.id !== undefined ? v.id !== filtro.value.id : v !== filtro.value
        );
        this.formSearch.get(filtro.campo)?.setValue(updated.length ? updated : null);
      }
    } else {
      this.formSearch.get(filtro.campo)?.reset();
    }
    //this.buscar(true);
  }

  get filtrosAplicados(): { label: string; campo: string; value?: any }[] {
    const filtros: { label: string; campo: string; value?: any }[] = [];

    const id = this.formSearch.get('idUsuario')?.value;
    if (id) filtros.push({ label: `Id: ${id}`, campo: 'idUsuario' });

    const usuarios = this.formSearch.get('usuarioSddr')?.value as any[];
    if (usuarios?.length) {
      usuarios.forEach((u: any) => {
        if (typeof u === 'object' && u !== null) {
          const label = [u.razonSocial, u.nima].filter(Boolean).join(' - ');
          filtros.push({ label: label.length > 35 ? label.slice(0, 33) + '…' : label, campo: 'usuarioSddr', value: u });
        } else {
          filtros.push({ label: String(u), campo: 'usuarioSddr', value: u });
        }
      });
    }

    const tipoEnvaseId = this.formSearch.get('tipoEnvase')?.value;
    if (tipoEnvaseId !== null && tipoEnvaseId !== undefined) {
      const found = this.tiposEnvases?.find((t) => t.id === tipoEnvaseId);
      filtros.push({ label: found?.descripcion ?? String(tipoEnvaseId), campo: 'tipoEnvase' });
    }

    const usoId = this.formSearch.get('usoEnvase')?.value;
    if (usoId !== null && usoId !== undefined) {
      const found = this.usosEnvases?.find((u) => u.id === usoId);
      filtros.push({ label: found?.name ?? String(usoId), campo: 'usoEnvase' });
    }

    const fDesde = this.formSearch.get('fechaDesde')?.value;
    if (fDesde) filtros.push({ label: `${moment(fDesde).format('DD/MM/YYYY')}`, campo: 'fechaDesde' });

    const fHasta = this.formSearch.get('fechaHasta')?.value;
    if (fHasta) filtros.push({ label: ` ${moment(fHasta).format('DD/MM/YYYY')}`, campo: 'fechaHasta' });

    const estadoIds = this.formSearch.get('estado')?.value as any[];
    if (estadoIds?.length) {
      estadoIds.forEach((estId: any) => {
        const found = this.estados?.find((e) => e.id === estId);
        filtros.push({ label: found?.descripcion ?? String(estId), campo: 'estado', value: estId });
      });
    }

    const autofacturada = this.formSearch.get('autofacturada')?.value;
    if (autofacturada !== null && autofacturada !== undefined) {
      filtros.push({ label: ` ${autofacturada ? 'Sí' : 'No'}`, campo: 'autofacturada' });
    }
const ordenes = this.formSearch.get('orden')?.value;
    if (Array.isArray(ordenes) && ordenes.length) {
      ordenes.forEach((ordenCodigo: any) => {
        filtros.push({
          label: `Orden: ${String(ordenCodigo)}`,
          campo: 'orden',
          value: ordenCodigo,
        });
      });
    } else if (ordenes) {
      filtros.push({ label: `Órdenes: ${String(ordenes)}`, campo: 'orden' });
    }

    const tipoOrden = this.formSearch.get('tipoOrden')?.value;
    if (tipoOrden) {
      const label =
        tipoOrden === 'ASC'
          ? 'Ascendente'
          : tipoOrden === 'DESC'
          ? 'Descendente'
          : String(tipoOrden);
      filtros.push({ label: `Tipo orden: ${label}`, campo: 'tipoOrden' });
    }
    return filtros;
  }

  buscar(initPage: boolean = false, init?: boolean): void {
    if(initPage){
      this.pageNumber = 0;
    }
    let filtro: SolicitudReutilizacionFilterDTO;
    filtro = this.getBackendFilter();
    const page = this.pageNumber <= 1 ? 0 : this.pageNumber - 1;
    this.spinnerSrv.loadingShow();
    const orden = this.formSearch.get('orden')?.value;
    const tipoOrden = this.formSearch.get('tipoOrden')?.value;
    this.openSddrSrv.buscarSolicitudesReutilizacion(filtro, {
      page: page, size: this.pageSize,
      sort: ['id,desc']
    },orden,tipoOrden
    ).subscribe({
      next: (data: any) => {
        this.spinnerSrv.loadingHide();
        if (data) {
          this.flagSearch = data?.datos?.length != 0 ? true : false;
          this.ocultarBuscador = ((this.canViewResource('AD-ADHERIDO') || this.canViewResource('PO-POSEEDOR')) && (!this.flagSearch && init == true));
          this.gridArray = this.canAccessAll(data?.datos);
          this.totalElements = data.paginacion?.totalElements ?? 0;
          this.totalSearch = this.gridArray.length;
        }
      },
      error: (error: any) => {
        this.spinnerSrv.loadingHide();
        this.snackBarSrv.showSnackBar(
          'Ha ocurrido un error al buscar las solicitudes de reutilización',
          'error'
        );
      },
    });
  }

  canAccessAll(list: any) {
    const resultView = this.authService.can('sddr-ca-solicitudes-reutilizacion', 'view');
    const resultDelete = this.authService.can('sddr-ca-solicitudes-reutilizacion', 'update-delete');
    const resultSendRequest = this.authService.can('sddr-ca-solicitudes-reutilizacion', 'update-send');
    const resultAcceptRequest = this.authService.can('sddr-ca-solicitudes-reutilizacion', 'update-accept');
    const resultRejectRequest = this.authService.can('sddr-ca-solicitudes-reutilizacion', 'update-reject');

    const listPermission = list.map((objeto: any) => {
      //Si poseedor o adherido solo podré eliminar las solicitudes que estén dadas de alta por él mismo
      const adPoDelete = objeto.creadoPor == this.authService.getCurrentUserMail() && (this.canViewResource('AD-ADHERIDO') || this.canViewResource('PO-POSEEDOR'));
      const isGest = this.canViewResource('SDDR-CA-ENV-GEST');

      return {
        ...objeto,
        canAccessView: resultView,
        canAccessDelete: (resultDelete && isGest && objeto.estado.id === 1) || (resultDelete && adPoDelete && objeto?.estado?.id === 1),
        canAccessSendReq: resultSendRequest && objeto.creadoPor == this.authService.getCurrentUserMail() && objeto?.estado?.id === 1, //PO_POSEEDOR y AD_ADHERIDO (sólo podrán enviar aquellas solicitudes que estén dadas de alta por el mismo)
        canAccessAcceptReq: resultAcceptRequest && objeto?.estado?.id === 2,
        canAccessRejectReq: resultRejectRequest && objeto?.estado?.id === 2
      };
    });

    return listPermission;
  }

  abrirModal(solicitud?: any): void {
    let soloLectura: boolean = true;
    if (this.canEditar() && (solicitud?.estado?.id === 1 || !solicitud?.id)) {
      soloLectura = false;
    }

    const dialogRef = this.dialog.open(
      OpenSsdrReuseDialogComponent,
      {
        width: '1460px',
        maxWidth: '95%',
        maxHeight: '95vh',
        data: {
          solicitudId: solicitud?.id,
          soloLectura: soloLectura,
          estados: this.estados
        },
        disableClose: true
      }
    );
    dialogRef.afterClosed().subscribe(
      result => {
        if (result) {
          this.buscar();
        }
      }
    );

  }

  abrirModalCertificado(){
    const dialogRef = this.dialog.open(
      OpenSsdrReuseCertificateDialogComponent,
      {
        width: '650px',
        maxWidth: '95%',
        maxHeight: '95vh',
        disableClose: true
      }
    );
    dialogRef.afterClosed().subscribe(
      result => {
        if (result) {
          this.buscar();
        }
      }
    );
  }

  exportarCsv(): void {
    let filter = this.getBackendFilter();
    this.spinnerSrv.loadingShow();
    this.solicitudesReutilizacionCtrlSrv.exportCSV1(filter)
      .subscribe({
        next: (response) => {
          this.downloadSrv.exportModal();
          this.spinnerSrv.loadingHide();
          // this.downloadSrv.downloadBlob(response, 'solicitudesReutilizacion_SDDR_CA.csv');
        },
        error: (err: any) => {
          this.spinnerSrv.loadingHide();
          this.snackBarSrv.showSnackBar(
            'Ha ocurrido un error al exportar las solicitudes de reutilización.',
            'error'
          );
        },
      });
  }

  getPoseedorDescription(obj: any) {
      const parts = [
      obj?.razonSocial,
      obj?.nima,
      obj?.denominacionCentro
    ].filter(Boolean);
    return parts.join(' - ');
  }

  getPoseedorObjectQuery(searchterm: string) {
    return {
      razonSocialOrNima: `${searchterm}`,
      'estado.id': 4,
    };
  }

  getFormControl(selectForm: any): FormControl {
    switch (selectForm) {
      case 'usuarioSddr': {
        return this.formSearch.get('usuarioSddr') as FormControl;
      }
      default: {
        return this.formSearch.get('') as FormControl;
      }
    }
  }


  getBackendFilter() {
    let fechaBusqueda: Array<string> = [];
    let fechaDesde = this.formSearch.get('fechaDesde')?.value;
    let fechaHasta = this.formSearch.get('fechaHasta')?.value;

    if (fechaDesde) {
      let formatDateDesde = moment(new Date(fechaDesde)).format('YYYY-MM-DD');
      formatDateDesde = `gte(${formatDateDesde})`;
      fechaBusqueda.push(formatDateDesde);
    }
    if (fechaHasta) {
      let formatDateHasta = moment(
        new Date(this.formSearch.get('fechaHasta')?.value)
      ).format('YYYY-MM-DD');
      if (fechaDesde) {
        formatDateHasta = `and(lte(${formatDateHasta}))`;
      } else {
        formatDateHasta = `lte(${formatDateHasta})`;
      }
      fechaBusqueda.push(formatDateHasta);
    }

    const selectUsuarioSddr = this.formSearch.get('usuarioSddr')?.value;
    let usuarioSddrFilter: any;
    if(selectUsuarioSddr && selectUsuarioSddr.length > 0){
      usuarioSddrFilter = {
        id: selectUsuarioSddr?.map((objeto: any) =>
          objeto.id !== undefined ? objeto.id : objeto
        ),
      }
    }else{
      usuarioSddrFilter = {
        id: [this.formSearch.get('idUsuario')?.value]
      }
    }
    const selectEstado = this.formSearch.get('estado')?.value;
    let selectEstadosId: any[] = [];
    if (selectEstado !== undefined && selectEstado !== null) {
      selectEstadosId = selectEstado.map((objeto: any) =>
        objeto.id !== undefined ? objeto.id : objeto
      );
    }

    const backendFilter: SolicitudReutilizacionFilterDTO = {
      // todo: arreglar tras cambio en el back
      estado: { id: selectEstadosId },
      tipoUsuario: this.formSearch.get('tipoUsuario')?.value,
      idUsuario: this.formSearch.get('idUsuario')?.value ? this.formSearch.get('idUsuario')?.value : undefined,
      usuarioSDDRCA: usuarioSddrFilter,
      tipoEnvase: { id: this.formSearch.get('tipoEnvase')?.value },
      //subTipoEnvase: { id: this.formSearch.get('subtipoEnvase')?.value },
      loteEnvase: this.formSearch.get('loteEnvase')?.value ? this.formSearch.get('loteEnvase')?.value : undefined,
      usoEnvase: this.formSearch.get('usoEnvase')?.value,
      autoFacturada: this.formSearch.get('autofacturada')?.value,
      fechaSolicitud: fechaBusqueda
    };

    return backendFilter;
  }
  confirmacionAutofactura(): void {
    Swal
      .fire({
        text: '¿Desea crear prefactura de las solicitudes seleccionadas en la tabla?',
        icon: 'question',
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: 'Sí',
        denyButtonText: 'No',
        allowOutsideClick: false,
      })
      .then((result: any) => {
        if (result.isConfirmed) {
          this.crearAutofactura();
        }
      });
  }

  crearAutofactura() {
    const list = this.gridArray.filter((x) => x.checked === true);

    if (list.length == 0) {
      this.snackBarSrv.showSnackBar(
        `Debe seleccionar al menos una solicitud para generar una prefactura`,
        'error'
      );
      return;
    }
    this.spinnerSrv.loadingShow();
    this.solicitudesReutilizacionCtrlSrv.crearAutofactura(list)
      .subscribe({
        next: (response: any) => {
          this.spinnerSrv.loadingHide();
          this.snackBarSrv.showSnackBar(
            'Se ha generado la prefactura correctamente.',
            'success'
          );
          this.buscar();
        },
        error: (err) => {
          this.spinnerSrv.loadingHide();
          let message = err.error?.arguments[0] ?? 'Ha ocurrido un error al generar la prefactura';
          this.snackBarSrv.showSnackBar(message, 'error');
        },
      });
  }
  confirmacionBorrar(element?: any): void {
    Swal
      .fire({
        text: '¿Desea eliminar la solicitud de reutilización?',
        icon: 'question',
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: 'Sí',
        denyButtonText: 'No',
        allowOutsideClick: false,
      })
      .then((result: any) => {
        if (result.isConfirmed) {
          this.borrarSolicitud(element?.id!);
        }
      });
  }
  borrarSolicitud(idSolicitud: number): void {
    this.spinnerSrv.loadingShow();
    this.solicitudesReutilizacionCtrlSrv.deleteByIdSolicitudReutilizacion(idSolicitud)
      .subscribe({
        next: (response: any) => {
          this.spinnerSrv.loadingHide();
          this.snackBarSrv.showSnackBar(
            'Se ha borrado la solicud de reutilización se ha realizado correctamente.',
            'success'
          );
          this.buscar();
        },
        error: (err) => {
          this.spinnerSrv.loadingHide();
          this.snackBarSrv.showSnackBar(
            'Ha ocurrido un error al borrar la solicitude de reutilización.',
            'error'
          );
        },
      });

  }
  confirmacionEnviar(element?: any): void {
    Swal
      .fire({
        text: '¿Desea enviar la solictud de reutilización?',
        icon: 'question',
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: 'Sí',
        denyButtonText: 'No',
        allowOutsideClick: false,
      })
      .then((result: any) => {
        if (result.isConfirmed) {
          this.enviarSolicitud(element?.id!);
        }
      });
  }
  enviarSolicitud(idSolicitud: number): void {
    this.spinnerSrv.loadingShow();
    this.solicitudesReutilizacionCtrlSrv.enviarSolicitud(idSolicitud)
      .subscribe({
        next: (response: any) => {
          this.spinnerSrv.loadingHide();
          this.snackBarSrv.showSnackBar(
            'Se ha enviado la solicitud de reutilización correctamente.',
            'success'
          );
          this.buscar();
        },
        error: (err) => {
          this.spinnerSrv.loadingHide();
          this.snackBarSrv.showSnackBar(
            'Ha ocurrido un error al enviar la solicitude de reutilización.',
            'error'
          );
        },
      });
  }
  confirmacionAceptar(element?: any): void {
    Swal
      .fire({
        text: '¿Desea aceptar la solictud de reutilización?',
        icon: 'question',
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: 'Sí',
        denyButtonText: 'No',
        allowOutsideClick: false,
      })
      .then((result: any) => {
        if (result.isConfirmed) {
          this.aceptarSolicitud(element?.id!);
        }
      });
  }
  aceptarSolicitud(idSolicitud: number): void {
    this.spinnerSrv.loadingShow();
    this.solicitudesReutilizacionCtrlSrv.aceptarSolicitud(idSolicitud)
      .subscribe({
        next: (response: any) => {
          this.spinnerSrv.loadingHide();
          this.snackBarSrv.showSnackBar(
            'Se aceptado la solicitud de reutilización correctamente.',
            'success'
          );
          this.buscar();
        },
        error: (err) => {
          this.spinnerSrv.loadingHide();
          this.snackBarSrv.showSnackBar(
            'Ha ocurrido un error al aceptar la solicitude de reutilización.',
            'error'
          );
        },
      });
  }
  
  openModalMotivoRechazo(item:any){
    const dialogRef = this.dialog.open(
      OpenSddrReuseRejectDialogComponent,
      {
        width: '750px',
        maxWidth: '95%',
        maxHeight: '95vh',
        data: {
          info: item,
        },
        disableClose: true,
      }
    );
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.buscar();
      }
    });
  }

  canViewResource(rol: string): boolean {
    return this.authService.hasCurrentUserRole(rol);
  }
  canCrearAutofactura(): boolean {
    return this.authService.can('sddr-ca-solicitudes-reutilizacion', 'create-autofactura');
  }
  canCrearSolicitud(): boolean {
    return this.authService.can('sddr-ca-solicitudes-reutilizacion', 'create');
  }
  canExportar(): boolean {
    return this.authService.can('sddr-ca-solicitudes-reutilizacion', 'update-exportar');
  }
  canEditar(): boolean {
    return this.authService.can('sddr-ca-solicitudes-reutilizacion-detalle', 'edit');
  }
  onlyNumberKey(event: KeyboardEvent) {
    const allowedKeys = ['Backspace', 'ArrowLeft', 'ArrowRight', 'Tab', 'Delete', 'Control'];

    if (event.ctrlKey && (event.key === 'c' || event.key === 'v')) return;

    // Permitir números y teclas adicionales definidas
    if (!/^[0-9;]$/.test(event.key) && !allowedKeys.includes(event.key)) {
      event.preventDefault();
    }
  }
}
